import { TrainCarIcon } from './TrainCarIcon';

/**
 * author: Google
 * id 20588836-2EC7-467D-9E72-15D3C4FE7C93
 * name train-car
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/train-car.svg
 * tags
 * - Transportation + Other 
 */
export const TransportationIcon = TrainCarIcon;
export default TransportationIcon